import { useTranslation } from 'react-i18next'
import { landingAssetsForLocale } from '../config/landingAssets'

interface HeroIntroUsProps {
  isSoldOut: boolean
}

export default function HeroIntroUs({ isSoldOut }: HeroIntroUsProps) {
  const { t, i18n } = useTranslation('landingPage')
  const assets = landingAssetsForLocale(i18n.language)

  if (isSoldOut && assets.soldOutNoticeImg) {
    return (
      <section className='px-4 pb-12 pt-4'>
        <div className='mx-auto flex w-full max-w-md flex-col items-center rounded-lg bg-[#FEFBE9] px-4 pb-8 pt-4'>
          <img
            src={assets.soldOutNoticeImg}
            alt={t('soldOut.noticeLogoAlt')}
            className='h-[89px] w-[137px]'
            loading='eager'
          />
          <div className='flex w-full flex-col gap-2'>
            <h1 className='text-gray-12 px-4 text-center text-xl font-bold leading-[1.4] tracking-[0.12px]'>
              {t('soldOut.noticeTitle')}
            </h1>
            <p className='px-2 text-center text-base leading-[1.6] text-black'>
              {t('soldOut.noticeBodyBeforeBold')}
              <strong>{t('soldOut.noticeBodyBold')}</strong>
              {t('soldOut.noticeBodyAfterBold')}
            </p>
          </div>
        </div>
      </section>
    )
  }

  return (
    <section className='px-4 py-12'>
      <h1 className='text-gray-12 whitespace-pre-line text-center text-base font-normal leading-relaxed'>
        {t('hero.intro')}
      </h1>
    </section>
  )
}
